// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1_Cp4","additionalInfo":"AgreementModal_additionalInfo__3MgPY"};